export default {
    name: "surveyCreate",
    methods: {
        routeToSurveysList() {
            this.$router.push("/surveys");
        }
    }
}